<template>
  <div class="comunicado-previsualizacion" v-if="model">
    <ComunicadoPrevisualizacionPortal v-if="model.Tipo === TipoComunicadoEnum.Portal" :model="model" />
    <ComunicadoPrevisualizacionEmail v-else :model="model" />
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted } from "vue";
import { useModalBuilder } from "@helpers/modal-building-helper";
import { closeButtonProps } from "@helpers/button-helper";
import { messageBoxResult } from "@components/dialogs/message-box";
import { TipoComunicadoEnum } from "@api/api";
import { ComunicadoPrevisualizacionModel } from "@components/comunicados/models/ComunicadoPrevisualizacionModel";
import ComunicadoPrevisualizacionPortal from "@components/comunicados/ComunicadoPrevisualizacionPortal.vue";
import ComunicadoPrevisualizacionEmail from "@components/comunicados/ComunicadoPrevisualizacionEmail.vue";

const props = defineProps({
  model: {
    type: Object as () => ComunicadoPrevisualizacionModel,
    required: true,
  }
});

onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);

  modal.addButton("close", closeButtonProps(), { toolbar: "bottom", location: "after" })
    .update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
});
</script>

<style lang="scss" scoped>
</style>
